module.exports = __webpack_public_path__ + "img/sybanner.9e9e9fb8.png";